import resultsTableStyle from 'src/components/View/Page/ResultsTable/resultsTable.style';

const resultsStyles = {
  ...resultsTableStyle,
  textMessages: {
    minWidth: 280,
    // Capped so it stops crowding out Share Code. Without a max this column
    // absorbs all remaining width and squeezes the two columns to its right.
    maxWidth: 520,
    whiteSpace: 'pre-wrap'
  },
  // A share code is 10 chars plus the copy icon; nowrap keeps it on one line
  // instead of breaking mid-code, which makes it unreadable and unclickable.
  shareCode: {
    minWidth: 150,
    whiteSpace: 'nowrap',
  },
  actions: {
    width: 80,
    whiteSpace: 'nowrap',
  },
  msgNum: {
    minWidth: 100,
    whiteSpace: 'nowrap',
  },
  scenario: {
    minWidth: 200,
    width: 350,
    whiteSpace: 'pre-line',
  },
  contextScope: {
    minWidth: 150,
    width: 190,
  },
  image: {
    minWidth: 150,
    '& img': {
      width: 150,
      height: 150,
      objectFit: 'contain',
      border: '1px solid #CCCCCC',
      borderRadius: 5,
      padding: 10,
      boxSizing: 'border-box',
      backgroundColor: '#FFFFFF',
    }
  }
};

export default resultsStyles;
